import { useEffect, useState } from "react";

import gtl from "@gaming/gtl";

/* eslint-disable @typescript-eslint/no-explicit-any */
import { OnboardingErrorType, OnboardingServerErrorType } from "../models/errors";
import { addTestLog } from "../server/crm/api/utils/testLogs";
import { telemetryIsActive } from "../server/utils/getTelemetryStatus";

// The format for url is actually just the path without host nor locale. i.e: '/publish/program-selection'
export const logError = (error: any, type: OnboardingErrorType) => {
  const errorResponse = (error as any)?.response;
  const errorData = errorResponse?.data;
  try {
    gtl.writeError(
      type,
      errorData?.message ?? errorData?.statusText,
      errorData?.code ?? errorResponse.status ?? 500,
      undefined,
      errorData?.stack
    );
  } catch (error) {}
};

export const logServerError = (message: string, type: OnboardingServerErrorType, error?: any) => {
  if (telemetryIsActive()) {
    gtl.writeError(type, message, undefined, undefined, error?.stack);
    console.log(`[ERROR][${type}]`, `${message} - ${error?.stack}`);
  } else {
    addTestLog(message);
  }
};

export const useCv = () => {
  const [cv, setCv] = useState<string | undefined | null>(undefined);
  useEffect(() => {
    if (!cv) {
      const cvDiv = document.getElementById("cv");
      const newCv = cvDiv?.getAttribute("data-cv");
      setCv(newCv);
    }
  }, [cv]);
  return cv;
};
